var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c("div", { attrs: { id: "subheader" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "main-container" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { attrs: { id: "container" } }, [
          _c("div", { attrs: { id: "list-header-maincontainer" } }, [
            _c("div", { attrs: { id: "list-header-container" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.txtBusqueda,
                    expression: "txtBusqueda"
                  }
                ],
                attrs: {
                  id: "busqueda",
                  type: "text",
                  placeholder: "Búsqueda por código o nombre del producto"
                },
                domProps: { value: _vm.txtBusqueda },
                on: {
                  keyup: _vm.onKeyDownHandler,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.txtBusqueda = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  attrs: { id: "nombreDeposito" },
                  on: { click: _vm.deleteDeposito }
                },
                [_vm._v(_vm._s(_vm.nombreDeposito))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.seleccion != 1,
                    expression: "seleccion != 1"
                  }
                ],
                attrs: { id: "seleccion-container" }
              },
              [
                _c(
                  "span",
                  { staticClass: "seleccion", on: { click: _vm.ckCategoria } },
                  [_vm._v(_vm._s(_vm.nombreCategoria))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.nombreCategoria.length > 0,
                        expression: "nombreCategoria.length>0"
                      }
                    ],
                    staticClass: "seleccion",
                    attrs: { id: "separador" }
                  },
                  [_vm._v("> ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "seleccion",
                    on: { click: _vm.ckSubcategoria }
                  },
                  [_vm._v(_vm._s(_vm.nombreSubcategoria))]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm.show
            ? _c(
                "div",
                { attrs: { id: "list-container" } },
                _vm._l(_vm.items, function(item) {
                  return _c("item-producto", {
                    attrs: { id: "list-prod", item: item },
                    on: { setItem: _vm.setSelection }
                  })
                })
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "btnContainer" } }, [
          _c(
            "button",
            { attrs: { id: "btnCarrito" }, on: { click: _vm.btnCarrito } },
            [_vm._v("IR AL CARRITO")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.seleccion == 4,
                expression: "seleccion==4"
              }
            ],
            attrs: { seleccion: _vm.seleccion }
          },
          [
            _c("div", { attrs: { id: "back-popup" } }),
            _vm._v(" "),
            _c("div", { attrs: { id: "popup-realizar-pedido" } }, [
              _c("div", { attrs: { id: "popup-btnClose-container" } }, [
                _c("img", {
                  staticStyle: { width: "20px", height: "20px" },
                  attrs: { id: "btnClose", src: "/dist/btnClose.png" },
                  on: { click: _vm.btnCerrarPopup }
                })
              ]),
              _vm._v(" "),
              _c("p", { attrs: { id: "popup-titulo" } }, [
                _vm._v("Ver Producto")
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "popup-container" } }, [
                _c("div", { attrs: { id: "popup-image-container" } }, [
                  _c("img", {
                    attrs: { id: "popup-image", src: _vm.imagenProducto }
                  })
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "popup-container-text" } }, [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "margin-top": "36px",
                        "font-size": "12px",
                        color: "rgb(194, 126, 43)",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v("Cod " + _vm._s(_vm.productoSelect.Codigo))]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-size": "15px",
                        color: "#5C666F",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.nombreProducto))]
                  ),
                  _vm._v(" "),
                  _c("p", { attrs: { id: "popup-descripcion-producto" } }, [
                    _vm._v(_vm._s(_vm.descripcionProducto))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "14px",
                        "font-size": "12px",
                        "font-weight": "400",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [
                          _vm._v(
                            "\n                  Precio Lista: \n             "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.moneyLabel) +
                            " " +
                            _vm._s(_vm._f("formatMoney")(_vm.precioListaComp)) +
                            "\n             "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.descuento > 0,
                          expression: "descuento > 0"
                        }
                      ],
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "5px",
                        "font-size": "12px",
                        "font-weight": "400",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [
                          _vm._v(
                            "\n                  Descuento: \n             "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.descuentoComp) +
                            " %\n             "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.descuento <= 0,
                          expression: "descuento <= 0"
                        }
                      ],
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "5px",
                        "font-size": "12px",
                        "font-weight": "400",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [
                          _vm._v(
                            "\n                  Descuento: \n             "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _vm._v("\n                  -\n             ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "20px",
                        "font-size": "16px",
                        "font-weight": "500",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [_vm._v("\n                  Precio:\n             ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.moneyLabel) +
                            " " +
                            _vm._s(
                              _vm._f("formatMoney")(_vm.precioProductoComp)
                            ) +
                            "                    \n             "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: this.productoSelect.ManejaStock,
                          expression: "this.productoSelect.ManejaStock"
                        }
                      ],
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "20px",
                        "font-size": "12px",
                        "margin-bottom": "0px",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [
                          _vm._v(
                            "\n                  Total Disponible:\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _vm._v(
                          "\n                 " +
                            _vm._s(_vm.stockActual) +
                            " uds.\n              "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "5px",
                        "font-size": "12px",
                        "font-weight": "500",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [_vm._v("\n                  CANTIDAD\n             ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.cantidadProducto,
                              expression: "cantidadProducto"
                            }
                          ],
                          class: {
                            popupCantidad: _vm.cantValida,
                            popupCantidadInv: !_vm.cantValida
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.cantidadProducto },
                          on: {
                            keyup: _vm.updateCantidad,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.cantidadProducto = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showPacks,
                          expression: "showPacks"
                        }
                      ],
                      staticClass: "fh lc",
                      staticStyle: { "margin-top": "2px" }
                    },
                    [
                      _c("div", {
                        staticClass: "fh lc",
                        staticStyle: { width: "100px" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fh cc" }, [
                        _c(
                          "div",
                          {
                            class: {
                              popupMaximoPorcentaje: _vm.esMultiploValido,
                              popupMaximoPorcentajeInv: !_vm.esMultiploValido
                            }
                          },
                          [
                            _vm._v(
                              "\n                      (Debe ser múltiplo de " +
                                _vm._s(_vm.UnidadesPorPedido) +
                                ")\n                  "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fh lc" }, [
                    _c("div", {
                      staticClass: "fh lc",
                      staticStyle: { width: "100px" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "fh cc" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.esMultiploValido,
                              expression: "!esMultiploValido"
                            }
                          ],
                          staticClass: "popupMaximoPorcentajeInv"
                        },
                        [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_vm.valorCercano) +
                              "\n                  "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-top": "25px",
                        "margin-bottom": "20px",
                        "font-size": "12px",
                        "font-weight": "500",
                        color: "#5C666F"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "fh lc",
                          staticStyle: { width: "100px" }
                        },
                        [_vm._v("\n                  SUBTOTAL\n             ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "fh cc",
                          staticStyle: { "font-size": "14px" }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.moneyLabel) +
                              " " +
                              _vm._s(_vm._f("formatMoney")(_vm.subtotal)) +
                              "\n             "
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mostrarDetalle,
                      expression: "mostrarDetalle"
                    }
                  ],
                  staticClass: "popup-container-inline",
                  staticStyle: { "margin-top": "40px" }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-top": "15px",
                        "margin-left": "65px"
                      },
                      attrs: { id: "popup-cantidad-label" }
                    },
                    [_vm._v("DETALLE")]
                  ),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.detalle,
                        expression: "detalle"
                      }
                    ],
                    attrs: { id: "popupDetalle" },
                    domProps: { value: _vm.detalle },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.detalle = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "0px" },
                  attrs: { id: "btnContainerPopup" }
                },
                [
                  _c(
                    "button",
                    {
                      attrs: { id: "btnCerrarPopup" },
                      on: { click: _vm.btnCerrarPopup }
                    },
                    [_vm._v("CANCELAR")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { id: "btnAgregarPopup" },
                      on: { click: _vm.btnAgregar }
                    },
                    [_vm._v("AGREGAR AL CARRITO")]
                  )
                ]
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Nuevo Pedido")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38f91d0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f91d0e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarPedido/realizarPedido.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-38f91d0e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/realizarPedido/realizarPedido.vue
// module chunks = 0